export function hasNodes({ nodes, type }) {
  if (!nodes || !Array.isArray(nodes)) {
    return false;
  }
  return nodes.some((node) => node.type === type);
}

export function nodesExist({ nodes, parentId }) {
  if (!nodes || !Array.isArray(nodes)) {
    return 0;
  }
  return (
    nodes.filter(
      (i) =>
        i.data?.parentData?.id === parentId &&
        i.type !== "descriptionIntentNode" &&
        i.type !== "defaultResponseIntentNode"
    )?.length - 1 || 0
  );
}
